import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78caa698"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "myLive" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "myLive_title" }, "展示样式", -1))
const _hoisted_3 = { class: "myLive_type" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "myLive_content" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "myLive_content_title" }, "内容设置", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "myLive_content_tip" }, "添加直播：默认显示前两个最新的直播，可上下拖拽直播间", -1))
const _hoisted_8 = { class: "myLive_content_setup" }
const _hoisted_9 = { class: "setup_title" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "模块标题", -1))
const _hoisted_11 = { class: "setup_input_length" }
const _hoisted_12 = { class: "setup_title" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "最多显示", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 直播间可以无限添加，最多显示的设置只显示在H5页面展示的数量，最多设置5个展示位，超过5个直播间H5展示更多按钮（设置2-3个展示位，添加四个直播间可显示更多按钮，同理设置2-3个展示位直播间只添加2-3个不会显示更多按钮） ", -1))
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "live_name" }

import draggable from 'vuedraggable';
import { ref, defineAsyncComponent } from 'vue';
import emitter from '@/utils/mitt';
import { QuestionCircleFilled } from '@ant-design/icons-vue';
import { InputNumber, Tooltip } from 'ant-design-vue';
import { dragDrop } from '@/utils/format/dragDrop';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyLive_setup',
  props: {
  custom: {},
  labelId: {},
},
  setup(__props) {

const props: any = __props;

const CDelModal = defineAsyncComponent(() => import('@/components/CDelModal.vue'));
const aInputNumber = InputNumber;
const aTooltip = Tooltip;
const AddLive = defineAsyncComponent(() => import('../live/addLive.vue'));



const mylive = ref();
mylive.value =
  props.custom.type == 6 || props.custom.type == 7
    ? { ...props.custom.tabsList[props.labelId].nestedList[0] }
    : { ...props.custom };
const getType = (index: number) => {
  mylive.value.style = index;
  mylive.value.liveList.map((res: any) => {
    res.style = index;
  });
  toVisualization();
};

const toVisualization = () => {
  if (props.custom.type == 6 || props.custom.type == 7) {
    const custom = { ...props.custom };
    custom.tabsList[props.labelId].nestedList[0] = { ...mylive.value };
    emitter.emit('visualization', custom);
  } else {
    emitter.emit('visualization', mylive.value);
  }
};
const liveId = ref();
const getLive = (index: number) => {
  liveId.value = index;
};

// 添加直播
const addlive = ref();
const showModal = () => {
  addlive.value.liveModal = true;
  addlive.value.showModal();
  addlive.value.getFileList();
};
// 删除直播间
const deleteModal = ref(false);
const deleteKey = ref();
const deleteLive = (index: number) => {
  deleteModal.value = true;
  deleteKey.value = index;
};
const deteleSelect = () => {
  mylive.value.liveList.splice(deleteKey.value, 1);
  deleteModal.value = false;
  const data = {
    id: 0,
    style: 0,
    image_player_cover_url: '',
    mode: null,
    start_at: '',
    status: null,
    title: '',
    number: null,
    live_url_status: null,
  };
  mylive.value.liveList.length == 0 ? mylive.value.liveList.push(data) : '';
};
// 接收添加直播间弹框确定
emitter.on('addlive', (e: any) => {
  if (mylive.value.liveList.length > 0 && mylive.value.liveList[0].image_player_cover_url) {
    //去重
    const screenList: any = [];
    e.map((res: any) => {
      const screen = mylive.value.liveList.filter((item: any) => {
        return item.id == res.id;
      });
      screen.length == 0 ? screenList.push(res) : '';
    });
    screenList.length !== 0 ? mylive.value.liveList.push(...screenList) : '';
  } else {
    mylive.value.liveList = [...e];
  }
  toVisualization();
});

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (item, index) => {
        return _createElementVNode("div", {
          key: item,
          class: _normalizeClass([mylive.value.style == index ? 'type_btn_click' : '', "type_btn"]),
          onClick: ($event: any) => (getType(index))
        }, [
          _createVNode(_component_svg_icon, {
            "icon-class": index == 0 ? 'myLive_type' : index == 1 ? 'myLive_type_one' : 'myLive_type_two'
          }, null, 8, ["icon-class"])
        ], 10, _hoisted_4)
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(_component_a_input, {
            class: "setup_input",
            placeholder: "请输入主标题",
            maxlength: 6,
            value: mylive.value.title,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((mylive.value.title) = $event)),
            onChange: toVisualization
          }, {
            suffix: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, _toDisplayString(mylive.value.title.length) + "/ 6", 1)
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode(_unref(aInputNumber), {
            value: mylive.value.most,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((mylive.value.most) = $event)),
            onChange: toVisualization,
            class: "setup_title_number",
            min: 1,
            max: 5
          }, null, 8, ["value"]),
          _createVNode(_unref(aTooltip), { placement: "left" }, {
            title: _withCtx(() => [
              _hoisted_14
            ]),
            default: _withCtx(() => [
              _createVNode(_unref(QuestionCircleFilled), { class: "setup_title_icon" })
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_a_button, {
          onClick: showModal,
          class: "myLive_content_btn"
        }, {
          default: _withCtx(() => [
            _createTextVNode("添加直播")
          ]),
          _: 1
        }),
        _createVNode(_unref(draggable), {
          list: mylive.value.liveList,
          handle: ".live_drag",
          animation: 150,
          "item-key": "id",
          onEnd: toVisualization,
          onDrop: _unref(dragDrop)
        }, {
          item: _withCtx(({ element, index }) => [
            (element.title)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "myLive_content_live",
                  onClick: ($event: any) => (getLive(index))
                }, [
                  _createElementVNode("div", _hoisted_16, _toDisplayString(element.title), 1),
                  _createVNode(_component_svg_icon, {
                    onClick: ($event: any) => (deleteLive(index)),
                    class: "live_delete",
                    style: _normalizeStyle({ display: liveId.value == index ? 'block' : 'none' }),
                    "icon-class": "solid_delete"
                  }, null, 8, ["onClick", "style"]),
                  _createVNode(_component_svg_icon, {
                    class: "live_drag",
                    "icon-class": "drag"
                  })
                ], 8, _hoisted_15))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["list", "onDrop"])
      ])
    ]),
    _createVNode(_unref(AddLive), {
      ref_key: "addlive",
      ref: addlive
    }, null, 512),
    (deleteModal.value)
      ? (_openBlock(), _createBlock(_unref(CDelModal), {
          key: 0,
          visible: deleteModal.value,
          centered: "",
          onClose: _cache[2] || (_cache[2] = ($event: any) => (deleteModal.value = false)),
          ok: deteleSelect
        }, null, 8, ["visible"]))
      : _createCommentVNode("", true)
  ]))
}
}

})